module.exports = __webpack_public_path__ + "img/DanHeadShot.ada8e11d.png";